import React from 'react';
import { useTranslation } from 'react-i18next';
import MemberCard from './MemberCard';

const EventMembers = ({ members, user }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden mb-8">
      <div className="p-6">
        <div className="mb-6">
          <h3 className="text-xl font-semibold text-gray-900">
            {t("player.eventMembers")} ({members.length})
          </h3>
        </div>

        {/* Members List */}
        <div className="space-y-3">
          {members.map((member) => {
            const isCurrentUser = member.userId === user?.id || 
                                 member.userId === user?._id || 
                                 member.userId === user?.metaData?.userId;
            
            return (
              <MemberCard
                key={member.userId}
                member={member}
                user={user}
                isCurrentUser={isCurrentUser}
              />
            );
          })}
        </div>

        {/* Attendance Summary */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <h4 className="text-sm font-semibold text-gray-700 mb-3">
            {t("player.attendanceSummary")}
          </h4>
          <div className="flex flex-wrap gap-3">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span className="text-sm text-gray-600">
                {t("player.attended")}: {members.filter(m => m.attendanceStatus === 'attended' || m.attendanceStatus === 'coming').length}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="text-sm text-gray-600">
                {t("player.absent")}: {members.filter(m => m.attendanceStatus === 'absent' || m.attendanceStatus === 'notComing').length}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
              <span className="text-sm text-gray-600">
                {t("player.maybe")}: {members.filter(m => m.attendanceStatus === 'doNotKnow').length}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
              <span className="text-sm text-gray-600">
                {t("player.pending")}: {members.filter(m => m.attendanceStatus === 'pending').length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventMembers; 